import ArrivedSwiper from "./ArrivedSwiper";

export * from ".";
export default ArrivedSwiper;